import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

export interface ServiceOrder {
    documentoId: number;
    id: string;
    vehicle: string;
    year: number | null;
    client: string;
    technician: string;
    status: string;
    rawStatus: string;
    issuedAt: string | null;
}

@Component({
    selector: 'app-service-card',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './service-card.component.html',
    styleUrls: ['./service-card.component.scss']
})
export class ServiceCardComponent {
    @Input() order!: ServiceOrder;

    get displayId(): string {
        return this.formatPlate(this.order.id);
    }

    get displayIssuedAt(): string {
        if (!this.order.issuedAt) {
            return '';
        }

        const date = new Date(this.order.issuedAt);
        if (Number.isNaN(date.getTime())) {
            return '';
        }

        return new Intl.DateTimeFormat('pt-BR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        }).format(date);
    }

    getStatusClass(status: string): string {
        const normalizedStatus = (status || '').trim().toUpperCase();

        switch (normalizedStatus) {
            case 'ABERTO':
                return 'status-open';
            case 'AUTORIZADO':
                return 'status-authorized';
            case 'FATURADO':
                return 'status-billed';
            case 'FECHADO':
                return 'status-closed';
            case 'LIBERADO':
                return 'status-released';
            case 'RECUSADO':
                return 'status-refused';
            case 'JUNÇÃO':
            case 'JUNCAO':
                return 'status-merge';
            default:
                if (normalizedStatus.includes('ANDAMENTO')) {
                    return 'status-in-progress';
                }

                if (normalizedStatus.includes('AGUARD')) {
                    return 'status-waiting';
                }

                if (
                    normalizedStatus.includes('PRONTO') ||
                    normalizedStatus.includes('CONCL') ||
                    normalizedStatus.includes('FINALIZ')
                ) {
                    return 'status-ready';
                }

                return 'status-default';
        }
    }

    private formatPlate(value: string): string {
        const compactValue = (value || '').trim().replace(/-/g, '').toUpperCase();
        if (!/^[A-Z]{3}[0-9][A-Z0-9][0-9]{2}$/.test(compactValue)) {
            return value;
        }

        return `${compactValue.slice(0, 3)}-${compactValue.slice(3)}`;
    }
}
